<div class="tabs dashboard-component-tabs is-boxed is-small is-marginless" >
  <ul>
    <li class="is-active">
      <a><span i18n>Plot Details</span></a>
    </li>
  </ul>
</div>

@if (plot | sortMonitors; as plot) {
  <div class="columns-wrapper">
    <div class="columns has-background-grey-lighter">
      <div class="column has-text-weight-semibold" i18n>Application data</div>
    </div>
    <div class="columns">
      <div class="column has-text-weight-semibold">
        <app-labeled-field label="ID" value="{{plot.id}}"></app-labeled-field>
      </div>
      @if (!userIsCustomer) {
        <div class="column">
          <app-labeled-field label="EFTAS-Zone" value="{{plot.eftasZone}}"></app-labeled-field>
        </div>
        <div class="column">
          <app-labeled-field label="EFTAS-ID" value="{{plot.eftasId}}"></app-labeled-field>
        </div>
      }
    </div>
    <div class="columns">
      <div class="column has-text-weight-semibold">
        <app-labeled-field label="NCode" value="{{plot.nCodeDeclared?.code}}: {{plot.nCodeDeclared?.codeLabel}}"></app-labeled-field>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <app-labeled-field label="Area" i18n-label value="{{plot.area ? math.round(plot.area * 100) / 100 + 'ha' : null}}"></app-labeled-field>
      </div>
      @if (!userIsCustomer) {
        <div class="column">
          <app-labeled-field label="Geometry size" i18n-label value=""></app-labeled-field>
        </div>
        <div class="column">
          <app-labeled-field label="Class" i18n-label value="{{plot.nCodeDeclared?.classCode}}"></app-labeled-field>
        </div>
      }
    </div>

    <div>
      <div class="columns has-background-grey-lighter">
        <div class="column has-text-weight-semibold" i18n>Metadata</div>
      </div>
      @if (metadata$ | async; as metadata) {
        @for (rowId of metadataRows(metadata.values) | keyvalue; track rowId) {
          <div class="columns">
            @for (item of metadata.values | keyvalue; track item) {
              @if (item.value.row === rowId.value) {
                <div class="column">
                    @if (metadata.booleanLabels.includes(item.key) && item.value.value != null && typeof item.value.value === 'boolean') {
                      <app-labeled-field label="{{item.key}}" value="{{item.value.value | boolean}}"></app-labeled-field>
                    } @else {
                      <app-labeled-field label="{{item.key}}" value="{{item.value.value}}"></app-labeled-field>
                    }
                </div>
                }
              }
          </div>
        }
      } @else {
        <div class="columns">
          <div class="column is-italic" i18n>No metadata available.</div>
        </div>
      }
    </div>

  @if (!userIsCustomer) {
    <div>
      <div class="columns has-background-grey-lighter">
        <div class="column has-text-weight-semibold">sFB</div>
      </div>
      @if (plot.getLastSfbAssessment(); as assessmentSfb) {
          <div class="columns">
            <div class="column">
              <app-labeled-field label="Operator" i18n-label value="{{assessmentSfb.operator}}"></app-labeled-field>
            </div>
            <div class="column">
              <app-labeled-field label="NCode-M" [ngClass]="{'primary': assessmentSfb.nCodeMeasured === plot.nCodeDeclared?.code, 'danger': assessmentSfb.nCodeMeasured !== plot.nCodeDeclared?.code}" value="{{assessmentSfb.nCodeMeasured}}"></app-labeled-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <app-labeled-field label="Comment" i18n-label value="{{assessmentSfb.comment}}"></app-labeled-field>
            </div>
            @if (plot.getSfbTags(); as sfbTags) {
              <div class="column">
                <app-labeled-field label="Tags" i18n-label></app-labeled-field>
                @for (tag of assessmentTags; track tag) {
                  <ul>
                    @if (sfbTags.includes(tag.name)) {
                      <li>{{tag.label}}</li>
                    }
                  </ul>
                }
              </div>
            }
        </div>

      } @else {
        <div class="columns">
          <div class="column is-italic" i18n>No sFB results yet.</div>
        </div>
      }
      


    </div>
  }

    <div class="columns has-background-grey-lighter">
      @if (plot.finalResults.length >= 1) {
        <div class="column has-text-weight-semibold">
          @if (!userIsCustomer) {
            <a (click)="toggleExpandFinalResults()">
              @if (finalResultsExpanded) {
                <i-feather name="chevron-down" class="icon-tiny"></i-feather>
              } @else {
                <i-feather name="chevron-right" class="icon-tiny"></i-feather>
              }
              &nbsp;
              <ng-container i18n>Final results</ng-container>
            </a>
          } @else {
            <div class="columns has-background-grey-lighter">
              <div class="column has-text-weight-semibold" i18n>Final results</div>
            </div>
          }
        </div>
      } @else {
        <div class="column has-text-weight-semibold" i18n>
          Final results
        </div>
      }
      

    </div>

    @if (plot.finalResults.length === 0) {
      <div class="columns">
        <div class="column is-italic" i18n>No Final results yet.</div>
      </div>
    }

      
    @if (finalResultsExpanded) {
      @if (!userIsCustomer) {
        @for (result of plot.finalResults; track result) {
          <div class="columns">
            <div class="column">
              <a (click)="toggleExpandFinalResult(result.monitor, result.updatedAt)">
                <div class="columns">
                  <div class="column is-4 results-column">
                    @if (isFinalResultExpanded(result.monitor, result.updatedAt)) {
                      <i-feather name="chevron-down" class="icon-tiny"></i-feather>
                    } @else {
                      <i-feather name="chevron-right" class="icon-tiny"></i-feather>
                    }
                    {{ getMonitorShortLabel(result?.monitor) }}
                  </div>
                  <div class="column is-2 results-column">
                    {{result?.nCodeMeasured}}
                  </div>
                  <div class="column is-3 results-column">
                    {{result?.resultCode}}
                  </div>
                  <div class="column is-1 results-column" [ngClass]="getCodeColor(result?.resultCode, result.monitor)">
                  </div>
                </div>
              </a>
            </div>
          </div>
          @if (isFinalResultExpanded(result.monitor,result.updatedAt)) {
            <div class="results bottom-line">
              <div class="columns">
                <div class="column">
                  <app-labeled-field label="Monitor" value="{{result.monitor}}"></app-labeled-field>
                </div>
                <div class="column">
                  <app-labeled-field label="NCode-M" value="{{result.nCodeMeasured}}"></app-labeled-field>
                </div>
                <div class="column">
                  <app-labeled-field label="Result code" i18n-label value="{{result.resultCode}}"></app-labeled-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <app-labeled-field label="Photo proof" i18n-label value="{{result.photoProof}}"></app-labeled-field>
                </div>
                <div class="column">
                  <app-labeled-field label="Date" i18n-label value="{{result.date | date}}"></app-labeled-field>
                </div>
                <div class="column">
                  <app-labeled-field label="Updated at" i18n-label value="{{result.updatedAt | date: 'short'}}"></app-labeled-field>
                </div>
              </div>
            </div>
          }
          
        }
        
      } @else {
        @for (result of plot.finalResults; track result) {
          <div class="columns">
            <div class="column">
              <a>
                <div class="columns">
                  <div class="column is-4 results-column">
                    <i-feather name="chevron-down" class="icon-tiny"></i-feather>
                    {{ result.monitor_?.internalName }}
                  </div>
                  <div class="column is-3 results-column">
                    {{result?.resultCode}}
                  </div>
                  <div class="column is-3 results-column" [ngClass]="translateCodeColor(result?.resultCode_?.color)">
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="results bottom-line">
            <div class="columns">
              <div class="column">
                <app-labeled-field label="Description" i18n-label value="{{result.monitor_?.description}}"></app-labeled-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <app-labeled-field label="Date" i18n-label value="{{result.date | date}}"></app-labeled-field>
              </div>
              <div class="column">
                <app-labeled-field label="Updated at" i18n-label value="{{result.updatedAt | date: 'short'}}"></app-labeled-field>
              </div>
            </div>
          </div>
          }
      }

    }


    @if (!userIsCustomer) {
      <div class="columns has-background-grey-lighter">
        @if (plot.results && plot.results.length >= 1) {
          <div class="column has-text-weight-semibold">
            <a (click)="toggleExpandResults()">
              @if (resultsExpanded) {
                 <i-feather name="chevron-down" class="icon-tiny"></i-feather>
              } @else {
                <i-feather name="chevron-right" class="icon-tiny"></i-feather>
              }
              &nbsp;
              <ng-container i18n>Results</ng-container>
            </a>
          </div>
        } @else {
          <div class="column has-text-weight-semibold" i18n>
            Results
          </div>
        }
      </div>

      @if (plot.results && plot.results.length === 0) {
        <div class="columns">
          <div class="column is-italic" i18n>No Results yet.</div>
        </div>
      }
      @if (resultsExpanded) {
        @for (result of plot.results; track result) {
          <div class="columns">
            <div class="column">
              <a (click)="toggleExpandResult(result.monitor, result.updatedAt)">
                <div class="columns">
                  <div class="column is-4 results-column">
                    @if (isResultExpanded(result.monitor, result.updatedAt)) {
                      <i-feather name="chevron-down" class="icon-tiny"></i-feather>
                    } @else {
                      <i-feather name="chevron-right" class="icon-tiny"></i-feather>
                    }
                    {{ getMonitorShortLabel(result?.monitor) }}
                  </div>
                  <div class="column is-4 results-column">
                    {{ result?.method }}
                  </div>
                  <div class="column is-2 results-column">
                    {{ result?.date | date : 'dd.MM.' }}
                  </div>
                  <div class="column is-1 results-column">
                    {{ result?.resultCode }}
                  </div>
                  <div class="column is-1 results-column">
                    {{ result?.nCodeMeasured }}                
                  </div>
                </div>
              </a>
            </div>
          </div>
          @if(isResultExpanded(result.monitor, result.updatedAt)) {
            <div class="results bottom-line">
              <div class="columns">
                <div class="column">
                  <app-labeled-field label="Monitor" i18n-label value="{{result.monitor}}"></app-labeled-field>
                </div>
                <div class="column">
                  <app-labeled-field label="Method" i18n-label value="{{result.method}}"></app-labeled-field>
                </div>
                <div class="column">
                  <app-labeled-field label="Result" i18n-label value="{{result.result}} {{result.resultCode}}"></app-labeled-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <app-labeled-field label="NCode-M" value="{{result.nCodeMeasured}}"></app-labeled-field>
                </div>
                <div class="column">
                  <app-labeled-field label="Date" i18n-label value="{{result.date | date}}"></app-labeled-field>
                </div>
                <div class="column">
                  <app-labeled-field label="Updated at" i18n-label value="{{result.updatedAt | date: 'short'}}"></app-labeled-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <app-labeled-field label="Comment" i18n-label value="{{result.resultComment}}"></app-labeled-field>
                </div>
              </div>
            </div>
          }
          
        }
      }
    }
  </div>
} @else { 
  <div class="content-placeholder" i18n>No plot selected.</div>
}


@if (false) {
  <table class="table is-narrow is-fullwidth table-compact">
    <tbody>
        <!--
        <ng-container *ngFor="let key of plot.keys"
                      [ngTemplateOutlet]="plot[key] !== null && plot[key] !== undefined ? (!hasChildren(plot[key]) ? tableRow : (isArray(plot[key]) ? multiRow : subTable)) : tableRow"
                      [ngTemplateOutletContext]="{key: key, value: plot[key]}">
        </ng-container>
        -->
    </tbody>
  </table>
}



<ng-template #multiRow let-key='key' let-array='value'>
  <tr>
    <th colspan="2" class="is-clickable	" (click)="expand(key)">
      @if (isExpanded(key)) {
        <i-feather name="chevron-down" class="icon-tiny"></i-feather>
      } @else {
        <i-feather name="chevron-right" class="icon-tiny"></i-feather>
      }
      {{key}}
    </th>
  </tr>

  @if (isExpanded(key)) {
    <ng-container *ngFor="let entry of array"
                  [ngTemplateOutlet]="subTable"
                  [ngTemplateOutletContext]="{key: '', value: entry}">
    </ng-container>
  }

</ng-template>

<ng-template #tableRow let-key='key' let-value='value'>
  <tr>
    <th class="has-text-left">{{key}}</th>
    @if (key === 'date' || key === 'updatedAt') {
      <td class="has-text-right">{{value | date:'short':'+0200':'de'}}</td>
    } @else {
      <td class="has-text-right">{{value}}</td>
    }
  </tr>
</ng-template>

<ng-template #subTable let-key='key' let-value='value'>
  @if (key && key.length >= 1) {
    <tr>
      <th colspan="2" class="is-clickable" (click)="expand(key)">
        @if (isExpanded(key)) {
          <i-feather name="chevron-down" class="icon-tiny"></i-feather>
        } @else {
          <i-feather name="chevron-right" class="icon-tiny"></i-feather>
        }
        {{key}}
      </th>
    </tr>
  }
  @if (!key || isExpanded(key)) {
    <tr>
      <td colspan="2">
        <table class="table is-narrow is-fullwidth table-compact">
          <tbody>
            <tr *ngFor="let subKey of getKeys(value)">
              <th>{{subKey}}</th>
              @if (subKey === 'date' || subKey === 'updatedAt') {
                <td class="has-text-right">{{value[subKey] | date:'short':'+0200':'de'}}</td>
              } @else {
                <td class="has-text-right">{{value[subKey]}}</td>
              }
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  }
</ng-template>
